const tableData = [
  {
    name: '工程主管',
    type: '工程技术',
    address: '武汉',
    time: '2021/6/1',
    count: 1,
    duty: [
      '1、负责现有产品深挖剖析，与行业内其他产品对比，建立产品线对外宣传体系，促进研发产品快速优化并通过项目落地应用',
      '2、售前技术交流沟通，调研客户需求，参与工程项目洽谈并设计规划方案',
      '3、负责项目方案细化规划设计，细化图纸、合同、投标文件、技术协议、商务文件的编写、制定与评审'
    ],
    require: [
      '1、机械设计制造及其自动化等相关机械专业，大学学历;',
      '2、具有3年以上物流自动化方案规划与细化工作经验;',
      '3、能够制定物流规划概念方案及参数，能独立做售前规划设计，具备招投标技术文件制定的能力;',
      '4、熟悉物流自动化行业知识，掌握常规物流场景规划与细化设计能力，掌握输送分拣系统设计能力；有立库和穿梭车库工作经验者优先；'
    ],
    email: 'inz56@jztey.com'
  },
  {
    name: '电气工程师（堆垛机、输送线、提升机、分拣机方向）',
    type: '工程技术',
    address: '武汉',
    time: '2021/6/1',
    count: 4,
    duty: [
      '1.负责物流设备的电气选型、电气图纸、PLC程序的开发工作',
      '2.负责物流设备现场程序调试与优化工作',
      '3.对上位机软件进行编程与优化，通过上位软件诊断设备问题',
      '4.参与公司现有设备的问题处理及优化改造工作。',
    ],
    require: [
      '1.大专以上学历，电气控制、自动化相关专业；',
      '2.熟练Office办公软件；',
      '3.精通CAD、PLC编程软件（西门子&三菱）, 熟悉WINCC、组态王VB等上位机软件编程。',
      '4.三年以上物流行业自动化开发经验，具有物流设备（堆垛机、输送线、提升机、分拣机等）电气开发、现场调试与优化。能独立完成电气选型、电控图纸绘制、PLC程序开发与调试工作；',
      '5.具备良好的沟通能力，团队合作精神，自我学习能力',
      '6.吃苦耐劳，能适应短期出差。'
    ],
    email: 'inz56@jztey.com'
  },
  {
    name: '物流自动化仿真工程师',
    type: '物流技术',
    address: '武汉',
    time: '2021/6/1',
    count: 3,
    duty: [
      '1.建立三维模型，协助仿真团队完成仿真模型的搭建。',
      '2.通过flexsim进行物流规划方案的仿真验证及优化，输出仿真报告。',
      '3.搭建仓储物流中心仿真模型，验证分析仓储物流中心运营方案，为仓储物流中心运营优化提供决策依据。',
      '4.搭建数字孪生物流中心，实时获取仓储物流中心信息，监控物流中心运行、诊断异常、输出异常对应调整方案至仓储物流中心。'
    ],
    require: [
      '1.计算机、自动化、工业工程、物流、机械等相关专业，本科以上学历；',
      '2.物流仿真项目经验2年及以上，能独立开展物流仿真相关项目。',
      '3.熟练使用sketchup或3D max。',
      '4.能够基于flexsim进行二次开发。',
    ],
    email: 'inz56@jztey.com'
  },
  {
    name: '设备工程师（堆垛机、输送线、提升机、分拣机方向）  ',
    type: '工程技术',
    address: '武汉',
    time: '2021/6/1',
    count: 3,
    duty: [
      '1.完成设备项目计划制定；',
      '2.进行项目进度及过程质量的控制跟进与反馈；',
      '3.具有设备安装与调试排障答疑能力，能对现场反馈的设备（自动化输送分拣、堆垛机、,AGV/RGV、机械手等）难题快速做出梳理，并提出成熟有效的解决方案；',
      '4.熟练现场安全管理规范，进行安全管理',
      '5.进行项目的验收和成果的交付，完成项目问题的收集和资料的收集和整理。',
    ],
    require: [
      '1.大专以上学历，电气控制、自动化、机械工程等相关专业；',
      '2.能熟练运用常用的办公软件和CAD绘图软件；',
      '3.有2年以上的设备项目施工和现场管理的经验，有自动化输送分拣、堆垛机、AGV/RGV、机械手相关项目经验优先考虑；',
      '4.具备良好的沟通能力，团队合作精神，自我学习能力；',
      '5.吃苦耐劳，能适应出差。',
    ],
    email: 'inz56@jztey.com'
  },
  {
    name: '规划工程师',
    type: '物流规划',
    address: '上海',
    time: '2021/6/1',
    count: 5,
    duty: [
      '1、承担方案售前工作；',
      '2、客户需求调研及需求分析；',
      '3、负责物流中心规划项目的物流集成方案设计、设备选型工作。',

    ],
    require: [
      '1、物流、机械、自动化、工业工程等相关专业；',
      '2、3年及以上的物流系统规划集成设计或售前规划相关的工作经验；',
      '3、能独立进行客户需求调研，熟悉仓运配作业流程，了解物流作业运作逻辑和成本构成；',
      '4、熟悉物流建筑设计防火规范、掌握GSP政策对物流设计的要求；',
      '5、具备良好的团队合作精神，能够适应经常性出差和承受较大的工作压力；',
      '6、熟练使用AUTOCAD绘图软件。',
    ],
    email: 'inz56@jztey.com'
  },
  {
    name: 'web前端工程师',
    type: '研发',
    address: '武汉',
    time: '2021/6/1',
    count: 5,
    duty: [
      '1.前端组件库的设计与开发',
      '2.前端框架迭代',
      '3.云开发平台的研发',
    ],
    require: [
      '1.前端基础扎实，精通javascript编程，熟悉前端性能优化。',
      '2.有良好的编程习惯和快速学习能力，能够深入技术研究，追求极致。',
      '3.有良好的面向对象开发思想，至少深入掌握一个主流库或者框架，如：React/Vue/Angular',
      '4.熟悉nodejs及前端工程化，至少精通一种前端构建工具，如：webpack、gulp',
      '5.具备良好的抽象设计能力，能封装复用性高、可维护性好的前端组件。',
      '6.有自助BI或者PAAS开发经验者优先。',
      '7.有webgl、three.js、thing.js开发经验者优先',
      '8.有跨平台开发经验者优先',
    ],
    email: 'inz56@jztey.com'
  },
  {
    name: '物流项目实施工程师',
    type: '项目实施',
    address: '武汉',
    time: '2021/6/1',
    count: 6,
    duty: [
      '1、负新建、改造物流中心项目的规划图纸细化，设施设备采购招标、基建前期跟踪、现场布置、设备安装调试、系统设备联调测试、运营辅导、物流中心搬迁、系统上线及优化验收等各项工作；',
      '2、制定与指导实施系统上线物流方案，包括全面解决方案、人员配置、模拟运行方案、搬迁方案、系统切换方案等。',
    ],
    require: [
      '1、物流管理相关专业，大专以上学历；',
      '2、具有扎实的物流专业知识，对物流管理、物流工程、供应链管理、运营管理及项目管理有一定的了解；',
      '3、熟练使用Office，CAD有一定了解，具有数据统计、数据分析及运用能力；',
      '4、具有较强的问题分析、解决及良好的沟通能力；',
      '5、工作细致，责任心强，有一定的团队协作精神；',
      '6、性格开朗，具有一定的抗压能力，能适应长期出差。',
    ],
    email: 'inz56@jztey.com'
  },
  {
    name: 'PMO管理',
    type: '项目管理',
    address: '武汉',
    time: '2021/6/1',
    count: 2,
    duty: [
      '1、结合集团及物流总公司相关部门管理要求，在项目管理委员会指导下，完善日常项目管理机制、配套流程或操作标准并推进落实；',
      '2、组织开展云仓公司各类项目年度预算的制定、评审、执行和监控工作；',
      '3、定期发布项目执行状态报告，就异常事项与项目经理沟通改进措施并协调跨部门资源需求；',
      '4、组织开展项目运行质量考核评估及奖励分配相关工作。',
    ],
    require: [
      '1、2年以上相关工作经验，拥有互联网或物流行业项目管理、项目交付、产品经理经验，具备', 'scrum master、PMP、PMP-ACP或PRINCE2证书者优先；',
      '2、熟练使用项目管理工具，熟悉项目流程，优秀的问题分析和解决能力；',
      '3、熟悉项目流程，有一定的成本和风险管控意识及计划统筹能力；',
      '4、善于沟通，具有良好的团队合作精神和协作能力，有团队管理能力和项目质量及进度的把控能力；',
      '5、良好的个人素养，优秀的沟通技巧与组织能力、协调能力及责任感；',
      '6、具备一定的文档书写能力，善于工作总结和问题；',
      '7、有责任心，工作踏实，正直诚恳，积极上进能与公司共同成长。',
    ],
    email: 'inz56@jztey.com'
  },
]

export const getRecruitData = () => tableData

const newsData =[
  {
      "news_id": "1108680585649725440",
      "news_type": "news",
      "news_title": "茅台循环产投公司工会、技术开发公司工会、物流公司工会联合举办2023年工会干部专题培训班",
      "images": "[https://obs-gzgy.cucloud.cn/cpsc-licence/微信图片_20230518085559_1684371419128.png]",
      "brief_content": "5月15日，茅台循环产投公司工会、技术开发公司工会、物流公司工会联合在中国劳动关系学院举办的2023年工会干部专题培训班开班，来自基层工会干部67人参加了培训。中国劳动关系学院继续教育学院（劳模学院、培训中心）副院长刘欣出席开班式并致辞，茅台技术开发公司党委副书记、工会主席张爱民主持会议。",
      "author": "龚永超",
      "origin": "",
      "detail_content": "<p>\"</p><p> &nbsp&lt&lt&lt&lt&lt&lt&lt &nbsp&lt&lt&lt&lt&lt&lt&lt &nbsp&lt&lt&lt&lt&lt&lt&lt 5月15日，茅台循环产投公司工会、技术开发公司工会、物流公司工会联合在中国劳动关系学院举办的2023年工会干部专题培训班开班，来自基层工会干部67人参加了培训。中国劳动关系学院继续教育学院（劳模学院、培训中心）副院长刘欣出席开班式并致辞，茅台技术开发公司党委副书记、工会主席张爱民主持会议。</p><p><br></p><p> &nbsp&lt&lt&lt&lt&lt&lt&lt &nbsp&lt&lt&lt&lt&lt&lt&lt &nbsp&lt&lt&lt&lt&lt&lt&lt开班仪式上，首先刘欣院长代表学院在致辞中介绍了中国劳动关系学院的发展及其学科优势，并希望学员能够通过培训学有所思、学有所获。其次，茅台物流公司工会主席唐扬莉通报五起培训活动相关违规案例。最后由循环产投工会主席欧苏就培训的目的意义、目标要求、培训纪律等代表作了动员讲话。讲话指出，全体学员一是要充分认识到提高工会工作质量的重要性。通过培训提升工会干部队伍素质，推动高质量工会工作，促进企业高质量发展。二是要充分认识高质量工会工作需要一支“能干事、会干事、干成事”的工会干部队伍，通过高质量的工会工作提升广大职工的幸福感、获得感、安全感。三是全体工会干部要珍惜此次培训机会，将培训内容学以致用，以用促学，把学到的新知识转化为推进工作的具体思路和方法举措，助力工会工作再上新台阶。</p><p> &nbsp&lt&lt&lt&lt&lt&lt&lt &nbsp&lt&lt&lt&lt&lt&lt&lt &nbsp&lt&lt&lt&lt&lt&lt&lt 随后，中国劳动关系学院马克思主义学院副院长田田以《党的二十大精神与新时代工会工作》为题，深入浅出阐述了党的二十大精神及新时代工会工作的新要求，引导学员们深入理解新时代工会工作。</p><p> &nbsp&lt&lt&lt&lt&lt&lt&lt &nbsp&lt&lt&lt&lt&lt&lt&lt &nbsp&lt&lt&lt&lt&lt&lt&lt 此次培训班为期5天，结合新时代工会工作要求，开设了《党的二十大精神与新时代工会工作》《职工之家规范化建设》《新工会法解读》《职工民主管理与职代会建设、代表履职能力提升》《工会干部素质提升与个人知识管理》《工会干部的礼仪知识素养》等课程，紧紧围绕“党的二十大精神与新时代工会工作创新发展”主题，采用专题理论学习、研讨交流和现场教学等方式进行。旨在通过培训，深入学习贯彻党的二十大精神，进一步提升工会干部业务水平，全面推进工会工作上新台阶，为企业高质量发展现代化建设贡献力量。</p><p><br></p>",
      "publish_date": "2023-08-09 14:59:01",
      "create_date": "2023-05-18 09:00:49",
      "update_date": "2023-08-09 14:59:01",
      "isAvailable": "Y",
      "topTime": "",
      "paramsjson": null,
      "order": null
  },
  {
      "news_id": "1110166358437797888",
      "news_type": "COMPANY_NEWS",
      "news_title": "茅台物流与川酒集团签订战略合作协议",
      "images": "[https://obs-gzgy.cucloud.cn/cpsc-licence/图片1_1684725231676.png]",
      "brief_content": "5月17日，茅台物流与川酒集团党委副书记、总经理杨官荣一行交流座谈，双方就深化物流服务、粮食贸易、粮储基地等方面业务合作进行研讨，并签订战略合作协议。",
      "author": "程瑞",
      "origin": "",
      "detail_content": "\"<p teshu2=\\\"text-indent: 32pt&lt text-align: justify&lt\\\"> &nbsp&lt5月17日，茅台物流与川酒集团党委副书记、总经理杨官荣一行交流座谈，双方就深化物流服务、粮食贸易、粮储基地等方面业务合作进行研讨，并签订战略合作协议。物流公司党委班子、经营班子，粮食收储公司有关负责人，川酒集团有关领导出席。</p><p teshu2=\\\"text-indent: 32pt&lt text-align: center&lt\\\"><teshu1 src=\\\"https://obs-gzgy.cucloud.cn/cpsc-licence/图片2_1684725314156.png\\\" alt=\\\"\\\" data-href=\\\"\\\" teshu2=\\\"width: 50%&lt\\\"></p><p teshu2=\\\"text-indent: 32pt&lt text-align: justify&lt\\\"> &nbsp&lt会上，双方基于自身优势，充分探讨战略合作方向、业务合作路径，双方一致认同深化交流合作、携手共赢的必要性，并表示今后将坚持资源共享、优势互补、互惠共赢的合作理念，整合产业资源，探索创新业态经营模式，共同推动实现高质量发展。</p><p teshu2=\\\"text-indent: 32pt&lt text-align: center&lt\\\"><teshu1 src=\\\"https://obs-gzgy.cucloud.cn/cpsc-licence/图片3_1684725382750.png\\\" alt=\\\"\\\" data-href=\\\"\\\" teshu2=\\\"width: 50%&lt\\\"></p><p teshu2=\\\"text-indent: 32pt&lt text-align: justify&lt\\\"> &nbsp&lt川酒集团党委副书记、总经理杨官荣表示，川酒集团始终坚持“整合酒企、壮大川酒”的使命，全力打造中国重点区域“一城一品”计划，破解区域品牌的销售瓶颈，打造中国白酒品牌集群，带领全省中小酒企抱团发展，走出了与名酒企业差异化的发展道路。希望双方依托各自资源覆盖范围和业务领域优势，共同打造协同创新、发展共赢的合作局面，为地方经济和行业发展作出更大贡献。</p><p teshu2=\\\"text-indent: 32pt&lt text-align: center&lt\\\"><teshu1 src=\\\"https://obs-gzgy.cucloud.cn/cpsc-licence/微信图片_20230522111711_1684725446278.jpg\\\" alt=\\\"\\\" data-href=\\\"\\\" teshu2=\\\"width: 50%&lt\\\"></p><p teshu2=\\\"text-indent: 32pt&lt text-align: justify&lt\\\"> &nbsp&lt &nbsp&lt物流公司党委书记、董事长姜世威对川酒集团杨官荣一行的到来表示欢迎，他表示，茅台物流在“大集团一盘棋、产业链一条心”的战略指导下，聚焦主责主业，着力构建酒类一体化供应链物流服务体系，进一步构筑起物流公司高质量发展的“四梁八柱”。下一步，物流公司将充分发挥自身发展优势，通过酒类一体化供应链物流服务体系为川酒集团物流、仓储、粮食贸易等业务发展赋能，努力推动双方资源共享、信息互通、优势互补，实现高水平互利共赢，携手共创美好未来。</p><p teshu2=\\\"text-indent: 32pt&lt text-align: center&lt\\\"><teshu1 src=\\\"https://obs-gzgy.cucloud.cn/cpsc-licence/图片5_1684725481876.png\\\" alt=\\\"\\\" data-href=\\\"\\\" teshu2=\\\"width: 50%&lt\\\"></p><p teshu2=\\\"text-indent: 32pt&lt text-align: justify&lt\\\"> &nbsp&lt物流公司党委副书记、总经理陈曦着重介绍了物流公司战略发展规划、年度“6+2”项重点工作任务开展情况，他表示，物流公司将进一步实现稳健发展、迸发发展活力，希望双方以此次战略合作为契机，不断拓展合作领域，逐步带动产业集群高标准、高质量发展。</p><p teshu2=\\\"text-indent: 32pt&lt text-align: center&lt\\\"><teshu1 src=\\\"https://obs-gzgy.cucloud.cn/cpsc-licence/图片1_1684725502755.png\\\" alt=\\\"\\\" data-href=\\\"\\\" teshu2=\\\"width: 50%&lt\\\"></p><p teshu2=\\\"text-indent: 32pt&lt text-align: center&lt\\\"> &nbsp&lt会上，姜世威和薛军强代表双方签署战略合作协议。</p><p teshu2=\\\"text-indent: 32pt&lt\\\"><br></p>\"",
      "publish_date": "2023-05-22 11:24:46",
      "create_date": "2023-05-22 11:24:45",
      "update_date": "2023-05-22 11:24:45",
      "isAvailable": "Y",
      "topTime": "",
      "paramsjson": null,
      "order": null
  },
  {
      "news_id": "1112757882296082432",
      "news_type": "COMPANY_PARTY_BUILDING",
      "news_title": "茅台物流公司党委书记带队到循环产投公司开展主题教育调研",
      "images": "[https://obs-gzgy.cucloud.cn/cpsc-licence/微信图片_202305261746563_1685343627447.jpg]",
      "brief_content": "为贯彻落实集团公司党委关于主题教育工作安排，牢牢把握“学思想、强党性、重实践、建新功”的总体要求，推动主题教育取得实效，5月18日下午，茅台物流公司党委书记、董事长姜世威率队到茅台循环产投公司开展主题教育调研，双方就如何高质量推动相关工作，促进公司共同发展进行深度交流",
      "author": "",
      "origin": "",
      "detail_content": "\"<p teshu2=\\\"text-indent: 32pt&lt\\\"><span teshu2=\\\"color: rgb(0, 0, 0)&lt\\\">为贯彻落实集团公司党委关于主题教育工作安排，牢牢把握“学思想、强党性、重实践、建新功”的总体要求，推动主题教育取得实效，5月18日下午，茅台物流公司党委书记、董事长姜世威率队到茅台循环产投公司开展主题教育调研，双方就如何高质量推动相关工作，促进公司共同发展进行深度交流。</span></p><p teshu2=\\\"text-indent: 32pt&lt\\\"><span teshu2=\\\"color: rgb(0, 0, 0)&lt\\\">物流公司党委委员、纪委书记赵尚刚，党委委员、党群工作部主任胡建华及相关部门负责人陪同调研，循环产投公司党委书记、董事长谢珺，党委委员、副总经理杨明开、张琴，副总经理袁安才，财务总监岳键英出席会议。</span></p><p teshu2=\\\"text-indent: 32pt&lt text-align: center&lt\\\"><teshu1 src=\\\"https://obs-gzgy.cucloud.cn/cpsc-licence/微信图片_202305261746563_1685343653340.jpg\\\" alt=\\\"\\\" data-href=\\\"\\\" teshu2=\\\"width: 50%&lt\\\"></p><p teshu2=\\\"text-indent: 32pt&lt\\\"><span teshu2=\\\"color: rgb(0, 0, 0)&lt\\\">座谈会上，循环产投公司党委书记、董事长谢珺对姜世威一行表示欢迎，双方就目前业务合作、业务结算、原料采购等工作进行深入交谈，并就围绕合作相关事宜进行沟通和交换意见。</span></p><p teshu2=\\\"text-indent: 32pt&lt text-align: center&lt\\\"><teshu1 src=\\\"https://obs-gzgy.cucloud.cn/cpsc-licence/微信图片_202305261746561_1685343681155.jpg\\\" alt=\\\"\\\" data-href=\\\"\\\" teshu2=\\\"width: 50%&lt\\\"></p><p teshu2=\\\"text-indent: 32pt&lt\\\"><span teshu2=\\\"color: rgb(0, 0, 0)&lt\\\">物流公司党委书记、董事长姜世威指出，今天此行的目的，</span><span teshu2=\\\"color: rgb(0, 0, 0)&lt font-family: 黑体&lt\\\">一方面是，</span><span teshu2=\\\"color: rgb(0, 0, 0)&lt\\\">当前，主题教育正在全党深入开展，以本次主题教育调研为契机，旨在推动学习贯彻习近平新时代中国特色社会主义思想主题教育走深走实。</span><span teshu2=\\\"color: rgb(0, 0, 0)&lt font-family: 黑体&lt\\\">另一方面是</span><span teshu2=\\\"color: rgb(0, 0, 0)&lt\\\">贯彻落实集团公司“大集团一盘棋，产业链一条心”的战略部署，通过深入交流，不断提出并完善更具针对性的物流服务方案，提供更好的物流服务保障，解决循环产投公司在物流保障服务方面的难点、痛点。</span></p><p teshu2=\\\"text-indent: 32pt&lt\\\"><span teshu2=\\\"color: rgb(0, 0, 0)&lt\\\">姜世威同志从八个方面介绍了物流公司在物流服务的优势，并表达了希望继续深化合作，按照集团公司战略部署，共同谱写循环产投公司与物流公司合作共赢、共同发展谱写崭新篇章的合作意愿。</span></p><p teshu2=\\\"text-indent: 32pt&lt text-align: center&lt\\\"><teshu1 src=\\\"https://obs-gzgy.cucloud.cn/cpsc-licence/微信图片_20230526174656_1685343707434.jpg\\\" alt=\\\"\\\" data-href=\\\"\\\" teshu2=\\\"width: 50%&lt\\\"></p><p teshu2=\\\"text-indent: 32pt&lt\\\"><span teshu2=\\\"color: rgb(0, 0, 0)&lt\\\">循环产投公司党委书记、董事长谢珺就茅台酒用高粱基地有机肥运输、酒糟运输等业务合作进行了介绍。他表示，后期要继续加强双方之间的交流沟通，从而达到共同学习、共同提高的目的，通过抓党建来促服务，推动党建与经营工作深度融合。</span></p><p teshu2=\\\"text-indent: 32pt&lt\\\"><span teshu2=\\\"color: rgb(0, 0, 0)&lt\\\">会后，物流公司党群工作部与循环产投公司党群工作部就如何将党建与生产经营深度融合、主题教育工作推进情况、支部标准化规范化建设等工作进行交流，物流公司纪检监察室与循环产投公司纪检监察室就关于如何开展好新时代廉洁文化建设、全面从严治党等工作进行交流。</span></p><p teshu2=\\\"text-indent: 32pt&lt\\\"><span teshu2=\\\"color: rgb(0, 0, 0)&lt\\\">茅台循环产投公司生产质量部、市场部、供应采购部、财务部、尊朋酒业相关负责人参加座谈会。</span></p>\"",
      "publish_date": "2023-05-29 15:02:33",
      "create_date": "2023-05-29 15:02:33",
      "update_date": "2023-05-29 15:02:33",
      "isAvailable": "Y",
      "topTime": "",
      "paramsjson": null,
      "order": null
  },
  {
      "news_id": "1112758860634267648",
      "news_type": "COMPANY_PARTY_BUILDING",
      "news_title": "茅台物流党委举办学习贯彻习近平新时代中国特色社会主义思想主题教育专题党课",
      "images": "[https://obs-gzgy.cucloud.cn/cpsc-licence/微信图片_202305261746564_1685343828119.jpg]",
      "brief_content": "为深入学习贯彻习近平新时代中国特色社会主义思想主题教育，牢牢把握“学思想、强党性、重实践、建新功”的总体要求，真正让主题教育在茅台物流走深走实。5月25日上午，茅台物流公司党委举办学习贯彻习近平新时代中国特色社会主义思想主题教育专题党课，茅台物流公司党委书记、董事长姜世威作了题为“深刻感悟中国共产党人的初心和使命”专题党课，公司党委委员、党群工作部主任胡建华主持会议。",
      "author": "",
      "origin": "",
      "detail_content": "\"<p teshu2=\\\"text-indent: 32pt&lt text-align: left&lt\\\"><span teshu2=\\\"color: rgb(0, 0, 0)&lt\\\">为深入学习贯彻习近平新时代中国特色社会主义思想主题教育，牢牢把握“学思想、强党性、重实践、建新功”的总体要求，真正让主题教育在茅台物流走深走实。5月25日上午，茅台物流公司党委举办学习贯彻习近平新时代中国特色社会主义思想主题教育专题党课，茅台物流公司党委书记、董事长姜世威作了题为“深刻感悟中国共产党人的初心和使命”专题党课，公司党委委员、党群工作部主任胡建华主持会议。</span></p><p teshu2=\\\"text-indent: 32pt&lt text-align: center&lt\\\"><teshu1 src=\\\"https://obs-gzgy.cucloud.cn/cpsc-licence/微信图片_202305261746564_1685343909584.jpg\\\" alt=\\\"\\\" data-href=\\\"\\\" teshu2=\\\"width: 50%&lt\\\"></p><p><span teshu2=\\\"color: rgb(0, 0, 0)&lt\\\"> &nbsp&lt &nbsp&lt &nbsp&lt &nbsp&lt专题党课主要从两个方面进行讲解，</span><span teshu2=\\\"color: rgb(0, 0, 0)&lt font-family: 黑体&lt\\\">一方面</span><span teshu2=\\\"color: rgb(0, 0, 0)&lt\\\">围绕主题教育的重大意义、具体内容和工作要求进行了系统深入的讲解；</span><span teshu2=\\\"color: rgb(0, 0, 0)&lt font-family: 黑体&lt\\\">另一方面</span><span teshu2=\\\"color: rgb(0, 0, 0)&lt\\\">围绕深入学习贯彻习近平新时代中国特色社会主义思想主题教育，深刻感悟中国共产党人的初心和使命，从“走近共产党人的初心”、“新时代新征程中国共产党的使命任务”、“茅台物流高质量发展的使命任务”三个角度，对不同历史时期共产党人的初心和使命进行了深入阐释，全面回答了“我是谁、我从哪里来、要到哪里去？”和“为了谁、干什么、怎么干？”这一根本问题。</span></p><p teshu2=\\\"text-indent: 32pt&lt text-align: center&lt\\\"><teshu1 src=\\\"https://obs-gzgy.cucloud.cn/cpsc-licence/微信图片_202305261746562_1685343943966.jpg\\\" alt=\\\"\\\" data-href=\\\"\\\" teshu2=\\\"width: 50%&lt\\\"></p><p teshu2=\\\"text-indent: 32pt&lt\\\"><span teshu2=\\\"color: rgb(0, 0, 0)&lt\\\">会议指出，今年是贯彻落实党的二十大精神的开局之年，是落实十四五战略规划承上启下的关键之年，也是茅台物流转型攻坚的决胜之年，当前，公司正大力推进转型攻坚工作，全体党员干部员工要充分认识到茅台物流高质量发展的使命任务，贯彻集团公司“大集团一盘棋，产业链一条心”的战略部署；切实增强党组织的政治功能和组织功能，加强党支部标准化规范化建设，将党建工作和生产工作深度融合；强化党员的党性教育，增强党员身份意识，要在生产经营中锤炼党性、检验党性和识别党性，让初心和使命成为每一位茅台物流党员干部员工鲜明的政治品格。</span></p><p teshu2=\\\"text-indent: 32pt&lt\\\"><span teshu2=\\\"color: rgb(0, 0, 0)&lt\\\">全体党员干部员工深受启发，纷纷表示要以本次主题教育和新风行动为契机，把习近平新时代中国特色社会主义思想转化为坚定理想、锤炼党性和指导实践、推动工作的强大力量，始终牢记“为中国人民谋幸福、为中华民族谋复兴”这一共产党人的初心和使命，“棋”心拼搏，勇毅前行，奋力谱写茅台物流高质量发展新篇章。</span></p><p><span teshu2=\\\"color: rgb(0, 0, 0)&lt\\\"> &nbsp&lt &nbsp&lt &nbsp&lt &nbsp&lt茅台物流公司全体党员、副主办及以上领导干部、员工代表参加党课。</span></p>\"",
      "publish_date": "2023-05-29 15:06:26",
      "create_date": "2023-05-29 15:06:26",
      "update_date": "2023-05-29 15:06:26",
      "isAvailable": "Y",
      "topTime": "",
      "paramsjson": null,
      "order": null
  },
  {
      "news_id": "1115283500753625088",
      "news_type": "LEARNING_EDUCATION",
      "news_title": "茅台物流工会开展“物流美课堂”之 普法行动&ls反诈知识培训",
      "images": "[https://obs-gzgy.cucloud.cn/cpsc-licence/图片2_1685945749034.png]",
      "brief_content": "为进一步提升广大职工防范电信网络诈骗意识及能力，维护职工合法权益，营造和谐健康的企业氛围。6月1日，公司工会开展了“物流美课堂”之普法行动&ls反诈知识培训会",
      "author": "",
      "origin": "",
      "detail_content": "\"<p> &nbsp&lt &nbsp&lt &nbsp&lt<span teshu2=\\\"font-size: 24px&lt\\\">为进一步提升广大职工防范电信网络诈骗意识及能力，维护职工合法权益，营造和谐健康的企业氛围。6月1日，公司工会开展了“物流美课堂”之普法行动&ls反诈知识培训会，本期美课堂公司工会邀请到招商银行业务部经理肖理杰同志进行授课。公司工会主席、各工会小组长、各部门员工代表30余人参加培训。</span></p><p teshu2=\\\"text-align: center&lt\\\"><teshu1 src=\\\"https://obs-gzgy.cucloud.cn/cpsc-licence/图片1_1685945779916.png\\\" alt=\\\"\\\" data-href=\\\"\\\" teshu2=\\\"width: 50%&lt\\\"></p><p> &nbsp&lt &nbsp&lt <span teshu2=\\\"font-size: 24px&lt\\\"> &nbsp&lt培训现场，讲师采用以案说教的方式，对电信网络诈骗常见的特点及如何识别防范电信诈骗的方法技巧进行了讲解，特别是对持续高发的网络博彩“杀猪盘”诈骗、网络兼职刷单诈骗、冒充电商物流客服诈骗等常见的电信网络诈骗犯罪手法套路进行了深入剖析解读，为参会人员作了一场精彩生动的反诈防骗知识培训，使大家对电信网络诈骗犯罪活动有了更为清醒深刻的认识，进一步增强了大家防范电信网络诈骗犯罪的意识，筑牢了防范打击电信网络诈骗违法犯罪的坚固屏障。</span></p><p teshu2=\\\"text-align: center&lt\\\"><teshu1 src=\\\"https://obs-gzgy.cucloud.cn/cpsc-licence/图片2_1685945811406.png\\\" alt=\\\"\\\" data-href=\\\"\\\" teshu2=\\\"width: 50%&lt\\\"></p><p> &nbsp&lt <span teshu2=\\\"font-size: 24px&lt\\\"> &nbsp&lt 通过此次培训，进一步提高了广大职工的安全防范意识和学法懂法用法的能力，提升了反诈骗的“辨别力”和“免疫力”，为保障公司行稳致远、健康发展起到了积极作用。</span></p>\"",
      "publish_date": "2023-06-05 14:18:26",
      "create_date": "2023-06-05 14:18:27",
      "update_date": "2023-06-05 14:18:27",
      "isAvailable": "Y",
      "topTime": "",
      "paramsjson": null,
      "order": null
  }
]

export const getNewsData = () => newsData

